import type { ReactNode } from 'react';

import * as SC from '@/components/common/buttons/Button.style';

export type ButtonTheme = 'primary' | 'secondary' | 'error';

type Props = {
  label: ReactNode;
  themeType?: ButtonTheme;
  labelStyle?: React.CSSProperties;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const Button = ({ label, themeType = 'primary', labelStyle, ...args }: Props) => {
  return (
    <SC.Wrapper themeType={themeType} {...args}>
      <SC.Label themeType={themeType} style={labelStyle}>
        {label}
      </SC.Label>
    </SC.Wrapper>
  );
};

export default Button;
